import { useState, useEffect } from "react";
import FTPConnect from "./FTPConnect";
import FileList from "./FileList";
import UploadFile from "./UploadFile";
import FolderTree from "./FolderTree";
import { getFiles } from "./ftpService";

export default function Fichiers() {
  const [isConnected, setIsConnected] = useState(false);
  const [credentials, setCredentials] = useState(null);
  const [files, setFiles] = useState([]);
  const [currentPath, setCurrentPath] = useState("/");

  // 🧠 déclenche automatiquement fetchFiles quand le chemin change
  useEffect(() => {
    if (isConnected) {
      fetchFiles(currentPath);
    }
  }, [currentPath, isConnected]);

  const handleConnectionSuccess = (host, username, password) => {
    setCredentials({ host, username, password });
    const savedPath = localStorage.getItem("ftpPath") || "/home/nanthiat";
    setCurrentPath(savedPath);
    setIsConnected(true);
  };

  const fetchFiles = async (path) => {
    try {
      console.log("📁 Récupération du contenu du dossier :", path);
      const data = await getFiles(path);
      setFiles(data);
    } catch (error) {
      console.error("❌ Erreur lors du chargement des fichiers :", error);
    }
  };

  return (
    <div className="flex space-x-4 p-6 bg-white rounded-none shadow-md w-full h-[92vh]">
      {isConnected && (
        <FolderTree setCurrentPath={setCurrentPath} credentials={credentials} />
      )}

      <div className="flex-1">
        {!isConnected ? (
          <FTPConnect setIsConnected={handleConnectionSuccess} />
        ) : (
          <>
            <UploadFile fetchFiles={() => fetchFiles(currentPath)} />
            <FileList
              files={files}
              setCurrentPath={setCurrentPath}
              fetchFiles={() => fetchFiles(currentPath)}
            />
          </>
        )}
      </div>
    </div>
  );
}
